import Main from '@/views/administracion/licitaciones/Main.vue';
import Default from '@/views/administracion/licitaciones/Default.vue';
import MainLicitacion from '@/views/administracion/licitaciones/licitacion/Main.vue';
import DefaultLicitacion from '@/views/administracion/licitaciones/licitacion/Default.vue';
import MainParticipantes from '@/views/administracion/licitaciones/licitacion/participantes/Main.vue';
import MainVisitaObra from '@/views/administracion/licitaciones/licitacion/visitaobra/Main.vue';
import MainJuntaAclaraciones from '@/views/administracion/licitaciones/licitacion/juntaaclaraciones/Main.vue';
import MainAperturaPropuestas from '@/views/administracion/licitaciones/licitacion/aperturapropuestas/Main.vue';
import MainFallo from '@/views/administracion/licitaciones/licitacion/fallo/Main.vue';
import MainEventos from '@/views/administracion/licitaciones/licitacion/eventos/Main.vue';
import MainEstadisticas from '@/views/administracion/licitaciones/estadisticas/Main.vue';
import Configuracion from './configuracion';

const auth = ['Licitaciones:ver'];
const scopes = ['Licitaciones:crear', 'Licitaciones:editar', 'Licitaciones:eliminar'];

const licitaciones = [
  {
    path: 'licitaciones',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'licitacionesEstadisticas',
        path: 'estadisticas',
        meta: {
          title: 'Licitaciones Estadisticas',
          auth,
          scopes,
        },
        component: MainEstadisticas,

        children: [],
      },
      ...Configuracion,
      {
        name: 'licitaciones',
        path: '/',
        meta: {
          title: 'Licitaciones',
          auth,
          scopes,
        },
        component: Default,

        children: [],
      },
      {
        path: ':idLicitacion',
        meta: {
          title: 'Licitacion',
          auth,
          scopes,
        },
        component: MainLicitacion,
        children: [
          {
            name: 'licitacion',
            path: '/',
            meta: {
              title: 'Licitacion',
              auth,
              scopes,
            },
            component: DefaultLicitacion,
          },
          {
            name: 'licitacionParticipantes',
            path: 'participantes',
            meta: {
              title: 'Licitacion Participantes',
              auth,
              scopes,
            },
            component: MainParticipantes,
          },
          {
            name: 'licitacionVisitaObra',
            path: 'visitaobra',
            meta: {
              title: 'Licitacion Visita de Obra',
              auth,
              scopes,
            },
            component: MainVisitaObra,
          },
          {
            name: 'licitacionJuntaAclaraciones',
            path: 'juntaaclaraciones',
            meta: {
              title: 'Licitacion Junta de Aclaraciones',
              auth,
              scopes,
            },
            component: MainJuntaAclaraciones,
          },
          {
            name: 'licitacionAperturaPropuestas',
            path: 'aperturapropuestas',
            meta: {
              title: 'Licitacion Apertura de Propuestas',
              auth,
              scopes,
            },
            component: MainAperturaPropuestas,
          },
          {
            name: 'licitacionFallo',
            path: 'fallo',
            meta: {
              title: 'Licitacion Fallo',
              auth,
              scopes,
            },
            component: MainFallo,
          },
          {
            name: 'licitacionEventos',
            path: 'eventos',
            meta: {
              title: 'Licitacion Eventos',
              auth,
              scopes,
            },
            component: MainEventos,
          },
        ],
      },
    ],
  },
];

export default licitaciones;
